import { NonEmptyArray } from 'shared/common/packages/JsonQuery';

export function getExtendedRegion(regionId: number): NonEmptyArray<number> {
  switch (regionId) {
    case 1:
    case 4593:
      return [1, 4593];

    case 2:
    case 4588:
      return [2, 4588];
  }

  return [regionId];
}
